(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempSectorSearch', TempSectorSearch);

    TempSectorSearch.$inject = ['$resource'];

    function TempSectorSearch($resource) {
        var resourceUrl =  'api/_search/temp-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
